import { AdOptions, AdSize, AdPosition } from "capacitor-admob";
import { Plugins, Capacitor } from '@capacitor/core';
import { Storage } from '@capacitor/storage';

import NServer from "../components/NServer";
import Vault from '../components/Vault';

const { AdMob } = Plugins;

export interface AdsInfo {
    appID : string;
    banner : string;
    interstitial : string;
    reward : string;
    testMode : boolean;
    delay : number;
    count : number;
};

// load admob data
export const ReadAdInfo = async () : Promise<AdsInfo> => {
    // read data
    let d = await Storage.get({ key: 'admob.appid' });
    const appID = d.value as string;
    
    d = await Storage.get({ key: 'admob.banner' });
    const banner = d.value as string;

    d = await Storage.get({ key: 'admob.inter' });
    const inter = d.value as string;

    d = await Storage.get({ key: 'admob.reward' });
    const reward = d.value as string;

    d = await Storage.get({ key: 'admob.test' });
    const testMode : boolean = d.value as string == "yes" ? true : false;

    d = await Storage.get({ key: 'admob.delay' });
    const delay : number = parseInt(d.value as string);

    d = await Storage.get({ key: 'admob.count' });
    const count : number = parseInt(d.value as string);

    const info = {
        appID : appID,
        banner : banner,
        interstitial : inter,
        reward : reward,
        testMode : testMode,
        delay : delay,
        count : count
    };

    return info;
}

// save the ad data
export const WriteAdInfo = async (info : AdsInfo) => {
    await Storage.set({
        key: 'admob.appid',
        value: info.appID,
    });

    await Storage.set({
        key: 'admob.banner',
        value: info.banner,
    });

    await Storage.set({
        key: 'admob.inter',
        value: info.interstitial,
    });

    await Storage.set({
        key: 'admob.reward',
        value: info.reward,
    });

    await Storage.set({
        key: 'admob.test',
        value: info.testMode ? "yes" : "no",
    });

    await Storage.set({
        key: 'admob.delay',
        value: "" + info.delay,
    });

    await Storage.set({
        key: 'admob.count',
        value: "" + info.count,
    });
}

var appInitID = "";
var adTimer : any = null;
var interAdStatus : number = 0;
var rewardAdStatus : number = 0;
var rewardShowing : boolean = false;

const RewardPointToUser = async () => {
    if (!rewardShowing)
        return;

    rewardShowing = false;

    let v = new Vault();
    await v.read();

    const state = {
        id: v.account.id,
        pass: v.account.key
    }

    var server = new NServer();
    await server.sendForm("ssv_social", state);
}

// Initialize the Admob
export const InitAdMobs = async () => {
    
    if (!Capacitor.isNative)
       return;

    const adInfo : AdsInfo = await ReadAdInfo();

    if (appInitID != adInfo.appID)
    {
        // initialize the AdMob
        let succeed = await AdMob.initialize(adInfo.appID);
        if (succeed)
            appInitID = adInfo.appID;
    }

    // preload interstitial ads
    let interOptions : AdOptions = {
        adId: adInfo.interstitial,
        autoShow: false,
        isTesting: adInfo.testMode
    };

    // Prepare interstitial banner
    if (interAdStatus < 1)
    {
        interAdStatus = 0;

        AdMob.prepareInterstitial(interOptions).then(
            (value : any) => {
            },
            (error : any) => {
                interAdStatus = -1;
            }
        );
 
        // Subscibe Banner Event Listener
        AdMob.addListener("onAdLoaded", (info: any) => {
            // inter ad is ready
            interAdStatus = 1;
        });
    }

    // preload the reward ads
    let rewardOptions : any = {
        adId: adInfo.reward,
        autoShow: false,
        isTesting: adInfo.testMode,
        userId: "user-123"
    };

    if (rewardAdStatus < 1)
    {
        rewardAdStatus = 0;

        AdMob.prepareRewardVideoAd(rewardOptions).then(
            (value : any) => {
            },
            (error : any) => {
                rewardAdStatus = -1;
            }
        );

        // Subscibe ReWardVideo Event Listener
        AdMob.addListener("onRewardedVideoAdLoaded", (info: any) => {
            rewardAdStatus = 1;
        });

        // Subscibe ReWardVideo Event Listener
        AdMob.addListener("onRewarded", (info: any) => {
            if (info.value)
                RewardPointToUser();
        });
    }

    // set timer
    adTimer = setInterval(() => {
        if (interAdStatus < 0)
        {
            interAdStatus = 0;
            // inter ad is error, reload it
            AdMob.prepareInterstitial(interOptions).then(
                (value : any) => {
                },
                (error : any) => {
                    interAdStatus = -1;
                }
            );
        }

        if (rewardAdStatus < 0)
        {
            rewardAdStatus = 0;
            // inter ad is error, reload it
            AdMob.prepareRewardVideoAd(rewardOptions).then(
                (value : any) => {
                },
                (error : any) => {
                    rewardAdStatus = -1;
                }
            );
        }

    }, 15000);
};

// check whether ad is ready or not
export const ReadyAds = async () : Promise<boolean> => {
    if (!Capacitor.isNative)
        return false;

    // check timer
    let d = await Storage.get({ key: 'admob.timer' });
    const timer : number = parseInt(d.value as string);
    console.log("Timer-> " + timer);
    if (isNaN(timer))
    {
        // set current time
        await Storage.set({
            key: 'admob.timer',
            value: "" + Date.now(),
        });
        return false;
    }
    
    d = await Storage.get({ key: 'admob.delay' });
    const delay : number = parseInt(d.value as string);
    if (isNaN(delay))
        return false;
    console.log("Delay-> " + delay + ", Now-> " + Date.now());
    if (timer + (delay * 1000) > Date.now())
        return false;

    // save current time
    await Storage.set({
        key: 'admob.timer',
        value: "" + Date.now(),
    });

    if (rewardAdStatus == 1 || interAdStatus == 1)
        return true;
    // else
    return false;
};

// show the ads
export const ShowAds = (onFinish : any) => {
    if (rewardAdStatus == 1)
    {
        rewardShowing = true;
        AdMob.showRewardVideoAd().then(
            (value : any) => {
                rewardAdStatus = 0;
                onFinish();
            },
            (error : any) => {
                rewardAdStatus = -1;
                onFinish();
            }
        );
        return;
    }

    if (interAdStatus == 1)
    {
        AdMob.showInterstitial().then(
            (value : any) => {
                interAdStatus = 0;
                onFinish();
            },
            (error : any) => {
                interAdStatus = -1;
                onFinish();
            }
        );
        return;
    }
}